import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthContext } from '../../shared/context/auth-context';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { ProfileSettingsLeftPanel } from './ProfileSettingsLeftPanel';
import { ProfileSettingsRightPanel } from './ProfileSettingsRightPanel';

const menuOptions = [
  { id: 41, title: 'account' },
  { id: 42, title: 'security' },
  { id: 43, title: 'notifications' },
];

const subMenuOptions = [
  { id: 51, title: 'profile' },
  { id: 52, title: 'password' },
  { id: 53, title: 'passcode' },
  { id: 54, title: 'delete_account' },
  { id: 55, title: 'reminders' },
  { id: 56, title: 'trackers' },
  { id: 57, title: 'languages' },
];

export function ProfileSettings({ isHidden }) {
  const { sendRequest } = useHttpClient();
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const pageName = window.location.pathname.split('/')[2];
  const subpageName = window.location.pathname.split('/')[3];
  const [activeMenu, setActiveMenu] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [profile, setProfile] = useState<any>(null);
  const [showRightMenu, setShowRightMenu] = useState<boolean>(false);
  const [showLeftMenu, setShowLeftMenu] = useState<boolean>(false);

  useEffect(() => {
    if (isHidden) {
      setShowRightMenu(false);
      setShowLeftMenu(true);
    } else {
      setShowRightMenu(true);
      setShowLeftMenu(true);
    }
  }, [isHidden]);

  useEffect(() => {
    const getProfile = async () => {
      try {
        const profile = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/users/profile`);
        if (profile) {
          setProfile(profile);
        }
      } catch (err) {}
    };
    if (!profile && auth.userId) {
      getProfile();
    }
  }, [auth.userId, profile]);

  useEffect(() => {
    if (!pageName) return;
    if (subpageName === 'notifications') {
      setActiveMenu(menuOptions[2]);
      setActiveSubMenu(subMenuOptions[4]);
    } else if (pageName === 'settings' && !activeMenu) {
      setActiveMenu(menuOptions[0]);
      setActiveSubMenu(subMenuOptions[0]);
    }
  }, [activeMenu, pageName, subpageName]);

  const saveProfile = async (newprofile) => {
    if (newprofile && auth.token) {
      let responseData;
      try {
        responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/users/profile`,
          'POST',
          JSON.stringify({
            profile: newprofile,
          })
        );
      } catch (err) {
        console.error(err);
      }
      if (responseData) {
        auth.profileHandler(newprofile);
      }
    }
  };

  const saveChanges = (props) => {
    const newprofile = { ...props };
    setProfile(newprofile);
    saveProfile(newprofile);
  };

  const saveProfileImage = (url) => {
    const newProfile = { ...profile, image: url };
    saveChanges(newProfile);
  };

  const changeMenu = (index, back) => {
    if (index === 2) {
      navigate('/profile/settings/notifications');
      setActiveSubMenu(subMenuOptions[4]);
    } else {
      setActiveMenu(menuOptions[index]);
    }
    if (isHidden && (back || index !== 0)) {
      setShowLeftMenu(true);
      setShowRightMenu(false);
    } else if (isHidden && !back && index === 0) {
      setShowLeftMenu(false);
      setShowRightMenu(true);
    }
    if (index === 1 && !isHidden) {
      setActiveSubMenu(subMenuOptions[1]);
    } else if (index === 1 && isHidden) {
      setActiveSubMenu(false);
    }

    if (index === 0) {
      setActiveSubMenu(subMenuOptions[0]);
    }
  };

  const changeSubMenu = (index) => {
    setActiveSubMenu(subMenuOptions[index]);
    if (isHidden) {
      setShowLeftMenu(false);
      setShowRightMenu(true);
    }
  };

  return (
    profile && (
      <div className="profile-container">
        {showLeftMenu && (
          <ProfileSettingsLeftPanel
            activeMenu={activeMenu}
            activeSubMenu={activeSubMenu}
            profile={profile}
            changeMenu={changeMenu}
            changeSubMenu={changeSubMenu}
            isHidden={isHidden}
            saveProfileImage={saveProfileImage}
          />
        )}
        {showRightMenu && (
          <ProfileSettingsRightPanel
            activeMenu={activeMenu}
            activeSubMenu={activeSubMenu}
            profile={profile}
            saveChanges={saveChanges}
            changeMenu={changeMenu}
            isHidden={isHidden}
          />
        )}
      </div>
    )
  );
}
